"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditPunch = void 0;
const react_1 = __importStar(require("react"));
const luxon_1 = require("luxon");
const react_i18next_1 = require("react-i18next");
const Checkbox_1 = require("@amzn/atoz-web/Checkbox");
const Datepicker_1 = require("@amzn/atoz-web/Datepicker");
const Hr_1 = require("@amzn/atoz-web/Hr");
const Flex_1 = require("@amzn/atoz-web/Flex");
const Text_1 = require("@amzn/atoz-web/Text");
const MessageBanner_1 = require("@amzn/atoz-web/MessageBanner");
const View_1 = require("@amzn/atoz-web/View");
const taaConfigs_1 = require("../../../../contexts/taaConfigs");
const logger_1 = require("../../../../logger");
const BIAnalytics_1 = __importDefault(require("../../../../utils/BIAnalytics/BIAnalytics"));
const EditPunchTypes_1 = require("./EditPunchTypes");
const TextTimeInput_1 = require("../../../../components/TextTimeInput");
const utils_1 = require("../../../../utils");
const useEditPunchStep_1 = require("./hooks/useEditPunchStep");
const context_1 = require("../../context");
const SpinnerOverlay_1 = require("../../../../components/SpinnerOverlay");
const PunchModalTypes_1 = require("../../../../components/PunchModal/PunchModalTypes");
const consts_1 = require("../../../../consts");
const EditPunch = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { payPeriodBreakdownInfo, setShowErrorFallback, setNewPunchDate, setNewPunchTime } = (0, context_1.usePunchWorkflowContext)();
    const { clientName } = (0, taaConfigs_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB,
        usageLocation: consts_1.featureNames.PUNCH_WORKFLOW_FEATURE
    };
    const { isAddPunch, isEditPunch, punchDetails, inputLabel, punchDate, setPunchDate, punchTime, setPunchTime, hasInputError, setHasInputError, inputErrorMessage, setInputErrorMessage, useMilitaryTime, toggleMilitaryTime, isLoading, error, lockoutStatus } = (0, useEditPunchStep_1.useEditPunchStep)();
    (0, react_1.useEffect)(() => {
        BIAnalytics_1.default.arriveEditPunchInPW();
    }, []);
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: isAddPunch
                ? logger_1.METRICS.PUNCH_WORKFLOW_ADD_PUNCH_STEP_RENDERED.COUNT
                : logger_1.METRICS.PUNCH_WORKFLOW_EDIT_PUNCH_STEP_RENDERED.COUNT
        },
        isComponentLoaded: !isLoading
    });
    (0, react_1.useEffect)(() => {
        setShowErrorFallback(!!error);
    }, [error]);
    const firstUpdate = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        validate();
    }, [punchTime, punchDate]);
    const validatePunchTime = (punchTime) => {
        return useMilitaryTime
            ? !/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/gm.test(punchTime)
            : !/^(1[0-2]|0?[1-9]):[0-5][0-9] (am|pm)$/gm.test(punchTime);
    };
    const validate = () => {
        if (punchDate.isValid) {
            setNewPunchDate(punchDate);
        }
        else {
            return false;
        }
        const isInvalid = validatePunchTime(punchTime || '');
        if (isInvalid) {
            setHasInputError(true);
            const errorMessage = isEditPunch
                ? t('time_and_attendance_PunchModal_PunchEditError_Time')
                : t('time_and_attendance_PunchModal_Error_Time');
            setInputErrorMessage(errorMessage);
            return false;
        }
        const parsedPunchTime = (0, utils_1.parsePunchTime)(punchTime || '', punchDate, useMilitaryTime);
        if (parsedPunchTime > luxon_1.DateTime.now()) {
            setHasInputError(true);
            const errorMessage = isEditPunch
                ? t('time_and_attendance_PunchModal_PunchEditError_Future')
                : t('time_and_attendance_PunchModal_Error_Future');
            setInputErrorMessage(errorMessage);
            return false;
        }
        setHasInputError(false);
        setNewPunchTime(punchTime);
        return true;
    };
    const textTimeInputClassName = 'time-input form-control' + (!!punchTime ? ' filled' : ' ');
    const textTimeInputClassNameError = 'time-input form-control error';
    const isDateDisabled = (date) => {
        var _a, _b;
        const dateTime = luxon_1.DateTime.fromISO(date);
        const isInFuture = dateTime > luxon_1.DateTime.now();
        const prevPayPeriodStart = ((_a = payPeriodBreakdownInfo === null || payPeriodBreakdownInfo === void 0 ? void 0 : payPeriodBreakdownInfo.previous) === null || _a === void 0 ? void 0 : _a.start_time)
            ? luxon_1.DateTime.fromISO(payPeriodBreakdownInfo.previous.start_time)
            : luxon_1.DateTime.now().minus({ days: 14 });
        const currPayPeriodEnd = ((_b = payPeriodBreakdownInfo === null || payPeriodBreakdownInfo === void 0 ? void 0 : payPeriodBreakdownInfo.current) === null || _b === void 0 ? void 0 : _b.end_time)
            ? luxon_1.DateTime.fromISO(payPeriodBreakdownInfo.current.end_time)
            : luxon_1.DateTime.now();
        const isInCurrAndPrevPayPeriod = (0, utils_1.isWithinDateTimeRange)(dateTime, prevPayPeriodStart, currPayPeriodEnd);
        return (isAddPunch && !isInCurrAndPrevPayPeriod) || isInFuture;
    };
    const renderBanner = () => {
        if (lockoutStatus.type === PunchModalTypes_1.LockoutStatusType.LOCKED_OUT) {
            logger_1.logger.emitCountMetric({
                metricName: logger_1.METRICS.MISSED_PUNCH_LIMIT_LOCKOUT.COUNT,
                dimensions
            });
        }
        return (react_1.default.createElement(MessageBanner_1.MessageBanner, { dataTestId: EditPunchTypes_1.EDIT_PUNCH_DATA_TEST_IDS.LOCKED_OUT_WARNING_BANNER, iconAltText: t('time_and_attendance_Warning'), type: lockoutStatus.type === PunchModalTypes_1.LockoutStatusType.WARNING
                ? MessageBanner_1.MessageBannerType.Warning
                : MessageBanner_1.MessageBannerType.Error }, lockoutStatus.message));
    };
    return (react_1.default.createElement(SpinnerOverlay_1.SpinnerOverlay, { isLoading: isAddPunch && isLoading },
        react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', margin: { bottom: 300 }, dataTestId: isAddPunch
                ? EditPunchTypes_1.EDIT_PUNCH_DATA_TEST_IDS.ADD_PUNCH
                : EditPunchTypes_1.EDIT_PUNCH_DATA_TEST_IDS.EDIT_PUNCH },
            isEditPunch && punchDetails && (react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', dataTestId: EditPunchTypes_1.EDIT_PUNCH_DATA_TEST_IDS.PUNCH_DETAILS, gridGap: 'S300' },
                punchDetails.map((detail) => !!detail.value && (react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', key: detail.label },
                    react_1.default.createElement(Text_1.Text, { fontSize: 'T200', color: 'neutral60' }, detail.label),
                    react_1.default.createElement(Text_1.Text, { fontSize: 'T200', color: 'neutral90' }, detail.value)))),
                react_1.default.createElement(Hr_1.Hr, null))),
            isAddPunch &&
                lockoutStatus.type !== PunchModalTypes_1.LockoutStatusType.OK &&
                renderBanner(),
            (isEditPunch ||
                (isAddPunch &&
                    lockoutStatus.type !== PunchModalTypes_1.LockoutStatusType.LOCKED_OUT)) && (react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', dataTestId: EditPunchTypes_1.EDIT_PUNCH_DATA_TEST_IDS.PUNCH_INPUTS, gridGap: 'S300', margin: { top: 'S300' } },
                react_1.default.createElement(Text_1.Label, { fontWeight: 'bold' }, inputLabel),
                react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row', gridGap: 'S200' },
                    react_1.default.createElement(View_1.View, { className: "atoz-filter-text-time-input", width: '35%' },
                        react_1.default.createElement(TextTimeInput_1.TextTimeInput, { onChange: (value) => {
                                BIAnalytics_1.default.changePunchTimeInPW();
                                setPunchTime(value);
                            }, className: hasInputError
                                ? textTimeInputClassNameError
                                : textTimeInputClassName, value: punchTime || '', placeholder: t('time_and_attendance_PunchModal_EnterTime'), militaryTime: useMilitaryTime, dataTestId: EditPunchTypes_1.EDIT_PUNCH_DATA_TEST_IDS.PUNCH_TIME_INPUT, ariaLabel: t('time_and_attendance_PunchModal_EnterTime') })),
                    react_1.default.createElement(View_1.View, { flexGrow: 1 },
                        react_1.default.createElement(Datepicker_1.PopupDatePicker, { isDateDisabled: isDateDisabled, defaultValue: punchDate.toISODate(), onChange: (value) => {
                                BIAnalytics_1.default.changePunchDateInPW();
                                setPunchDate(luxon_1.DateTime.fromISO(value));
                            }, inputProps: {
                                width: '100%',
                                error: !punchDate.isValid,
                                'aria-label': t('time_and_attendance_PunchWorkflow_SelectDateStep_Title')
                            }, dataTestId: EditPunchTypes_1.EDIT_PUNCH_DATA_TEST_IDS.PUNCH_DATE_PICKER }))),
                hasInputError && (react_1.default.createElement(MessageBanner_1.MessageBanner, { dataTestId: EditPunchTypes_1.EDIT_PUNCH_DATA_TEST_IDS.PUNCH_INPUTS_ERROR, iconAltText: t('time_and_attendance_Error'), type: MessageBanner_1.MessageBannerType.Error }, inputErrorMessage)),
                react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row', alignItems: 'center', gridGap: 'S200' },
                    react_1.default.createElement(View_1.View, { onClick: toggleMilitaryTime },
                        react_1.default.createElement(Checkbox_1.Checkbox, { dataTestId: EditPunchTypes_1.EDIT_PUNCH_DATA_TEST_IDS.MILITARY_TIME_CHECKBOX, id: EditPunchTypes_1.EDIT_PUNCH_DATA_TEST_IDS.MILITARY_TIME_CHECKBOX, checked: !useMilitaryTime })),
                    react_1.default.createElement(Text_1.Label, { htmlFor: EditPunchTypes_1.EDIT_PUNCH_DATA_TEST_IDS.MILITARY_TIME_CHECKBOX }, t('time_and_attendance_PunchModal_MissedPunchUseMilitaryTime'))),
                react_1.default.createElement(View_1.View, { margin: { top: 'S300' } },
                    react_1.default.createElement(Hr_1.Hr, null)))))));
};
exports.EditPunch = EditPunch;
